// 高级设置
import React from "react";
import { framework_tool, component_tool, utils_tool } from '@/tool'
import { connect } from "dva";
import { WizTaskSet, WizFeaturedSet, WizNoticeSet, WizSceneAudienceSet, WizPreconditions, WizManageAuth } from "@/containers/common";

const { WizContainer, modelUtils } = framework_tool
const { WizTabs,WizModal } = component_tool

const bizMap = new Map()
bizMap.set(0,  ['status', { 0: ['MessageNotificationSet'], 1: [ 'taskSet', 'recommendSet','MessageNotificationSet', 'sceneAudience'] }]) // 课程
bizMap.set(25, ['state',  { 0: ['manageAuth'],1: ['recommendSet', 'sceneAudience', 'manageAuth'] }]) // 系列化课程
bizMap.set(12, ['state',  {  1: ['manageAuth'],2: ['recommendSet', 'sceneAudience','manageAuth'], 3: ['manageAuth'] }]) // 培训路径
bizMap.set(1,  ['status', { 0: ['MessageNotificationSet', 'manageAuth','preconditions'], 1: ['taskSet', 'recommendSet', 'MessageNotificationSet', 'sceneAudience', 'manageAuth','preconditions'] }]) // 考试
bizMap.set(15, ['status', { 0: ['MessageNotificationSet', 'preconditions','manageAuth'], 1: ['taskSet', 'recommendSet', 'MessageNotificationSet', 'sceneAudience', 'preconditions','manageAuth'],2: ['manageAuth'],3: ['manageAuth'] }]) // 报名
bizMap.set(30, ['state',  { 1: ['sceneAudience','MessageNotificationSet'] }]) // 作业
bizMap.set(26, ['state',  { 1: [ 'manageAuth'], 2: ['taskSet', 'recommendSet', 'sceneAudience', 'manageAuth'], 3: ['taskSet', 'recommendSet', 'sceneAudience', 'manageAuth'] }]) // 直播
bizMap.set(2,  ['status', { 1: ['recommendSet', 'sceneAudience'] }]) // 问卷
bizMap.set(20, ['releaseState', { 1: ['recommendSet', 'sceneAudience','manageAuth'] }]) // 内容-公告
bizMap.set(23, ['state', { 1: ['MessageNotificationSet'] }]) // 活动
bizMap.set(21, ['state', { 1: ['preconditions'] }]) // 证书
bizMap.set(47, ['authState', { 0: ['taskSet'] }]) // 远程评估
bizMap.set(48, ['state', { 1: ['manageAuth','sceneAudience'] }]) // 车联考试
bizMap.set(52, ['status', { 0: ['manageAuth'],1: ['manageAuth'] }]) // 证书路径阶段配置
bizMap.set(53, ['status', { 0: ['manageAuth'] }]) // 性格测试管理
bizMap.set(36, ['status', { 1: ['MessageNotificationSet'] }]) // 班级
bizMap.set(8, ['status', { 0: ['manageAuth'],1: ['manageAuth'],2: ['manageAuth'] }]) // 线下课程
bizMap.set(40,  ['state', { 0: ['manageAuth'], 1: ['manageAuth'] }]) // 考试模版

const filterTabItems = (menuBtns = [], tabItems = []) => menuBtns.filter(val => tabItems.includes(val.code))

class HighSet extends WizContainer {

  constructor(props) {
    super(props)
    let { bizType, record } = props.data
    record.startDate = record.startDate || record.startTime
    record.endDate = record.endDate || record.endTime
    record.name = record.name || record.title
    this.menuBtn = this.getMenuBtn() || []
    let order = {
      taskSet: '1',
      recommendSet: '2',
      MessageNotificationSet: '3',
      sceneAudience: '4',
      preconditions: '5',
      manageAuth: '6',
    }
    if(record.categoryNames && record.categoryNames.includes("天天学练")) {
      bizMap.set(20, ['releaseState', { 1: ['taskSet'] }]) // 内容-天天学练
    }
    const bizItem = bizMap.get(bizType)
    this.tabItems = bizItem[1][record[bizItem[0]]]
    this.filterTabItems = filterTabItems(this.menuBtn, this.tabItems)

    this._activeKey = this.filterTabItems.map((btn) => {
      return btn && btn['code'] && order[btn['code']] ? order[btn['code']] : false
    }).filter(Boolean);

    this.state = {
      bizType,
      record,
      initNow: new Date().getTime(),
      taskId: 0,
      activeKey: this._activeKey[0] ? this._activeKey[0] + '' : '1'
    }

  }

  _checkNextTab(nowKey) {
    let r = false
    let keyIndex = this._activeKey.indexOf(nowKey);
    if (keyIndex < this._activeKey.length - 1) {
      r = this._activeKey[keyIndex + 1]
    }
    return r
  }

  _componentDidMount() {
    let { record, bizType } = this.state
    let { id } = record
    let actions= {
      taskSet: {
        path: 'taskInfo/taskList',
        payload: {
          key: 'taskInfo@taskList',
          apiParams: {
            bizId: id,
            bizType: bizType
          }
        }
      },
      recommendSet: {
        path: 'featured/list',
        payload: {
          key: 'featured@featuredList',
          apiParams: {
            entityId: id,
            entityType: bizType
          }
        }
      },
      MessageNotificationSet: {
        path: 'noticeTemplate/noticeInfoList',
        payload: {
          key: 'noticeTemplate@noticeList',
          apiParams: {
            businessId: id,
            bizType: bizType
          }
        }
      },
      sceneAudience: {
        path: 'apply/authInfo',
        payload: {
          key: 'authInfoKey',
          apiParams: { id: id }
        }
      }
    }
    let pushActions = this.filterTabItems.map((btn) => {
      return btn && btn['code'] && actions[btn['code']] ? actions[btn['code']] : false
    }).filter(Boolean);
    pushActions.push(
      {
        path: 'thirdApp/labelInfo',
        payload: {
          key: 'thirdApp@labelInfo',
          apiParams: {
          }
        }
      })
    this.doActions(pushActions)
  }

  propsAndStateOnChange = {
    authInfo: this._authInfo.bind(this),
    taskData: this._findTaskData.bind(this),
    taskNoticeData: this._findTaskNoticeData.bind(this),
    messageData: this._findMessageData.bind(this),
    featuredData: this._findFeaturedData.bind(this),
    addTaskInfo: this._addTaskInfo.bind(this),
    addFeaturedData: this._addFeaturedData.bind(this),
    addMessageData: this._addMessageData.bind(this),
    labelInfo: this._labelInfo.bind(this)
  };

  //查询所有app
  _labelInfo(nextProps, nextState) {
    let { labelInfo } = nextProps
    if (labelInfo && labelInfo['success']) {
      nextState['labelInfo'] = labelInfo['data'];
      nextState['initNow'] = new Date().getTime()
      return true
    } else {
      wizNotice.error(labelInfo && labelInfo['msg'] || '操作失败,请稍后尝试')
      return false
    }
  }
  _authInfo(nextProps, nextState) {
    let { authInfo } = nextProps
    if (authInfo && authInfo['success']) {
      nextState.authInfo = authInfo['data']
    } else {
      wizNotice.error(authInfo && authInfo['msg'] || '操作失败,请稍后尝试')
    }
    return false
  }

  _findTaskData(nextProps, nextState) {
    let { taskData } = nextProps
    if (taskData && taskData.code == 1) {
      if (taskData.success) {
        taskData.data && taskData.data.length && taskData.data.forEach((data) => {
          nextState.taskInfo = data
          nextState.taskId = data.id
        })
      }
      if (nextState && nextState.taskId && nextState.taskId > 0) {
        this.doAction(
          {
            path: 'noticeTemplate/taskNoticeInfoList',
            payload: {
              key: 'noticeTemplate@taskNoticeList',
              apiParams: {
                businessId: nextState.taskId,
                bizType: 38
              }
            }
          }
        )
      } else {
        this.doAction(
          {
            path: 'noticeTemplate/taskNoticeInfoList',
            payload: {
              key: 'noticeTemplate@taskNoticeList',
              apiParams: {
                businessId: 0,
                bizType: 38
              }
            }
          }
        )
      }
    } else {
      wizNotice.error('查看任务信息失败：' + nextProps.taskData.msg);
    }
    return true;
  }

  _findTaskNoticeData(nextProps, nextState) {
    let { taskNoticeData } = nextProps
    if (taskNoticeData.code == 1) {
      if (taskNoticeData && taskNoticeData.success) {
        nextState.taskNoticeData = taskNoticeData.data
        nextState.initNow = new Date().getTime()
      }
    } else {
      wizNotice.error('查看任务通知信息失败：' + nextProps.taskNoticeData.msg);
    }
    return true;
  }

  _findMessageData(nextProps, nextState) {
    let { messageData } = nextProps
    if (messageData.code == 1) {
      if (messageData && messageData.success) {
        nextState.messageData = messageData.data
      }
    } else {
      wizNotice.error('查看通知信息失败：' + nextProps.messageData.msg);
    }
    return true;
  }

  _findFeaturedData(nextProps, nextState) {
    let { featuredData } = nextProps
    if (featuredData && featuredData.code == 1) {
      if (featuredData.success) {
        featuredData.data && featuredData.data.length && featuredData.data.forEach((data) => {
          nextState.featuredData = data
        })
      }
    } else {
      wizNotice.error('查看推荐信息失败：' + nextProps.featuredData.msg);
    }
    return true;
  }

  _addTaskInfo(nextProps, nextState) {
    let { addTaskInfo, changeModal } = nextProps
    if (addTaskInfo && addTaskInfo.code == 1) {
      if (addTaskInfo.success) {
        nextState.taskId = addTaskInfo.data
        let {taskNoticeInfo,taskId} = nextState

    if (taskId) {
      this.doAction({
        path: 'noticeTemplate/saveTaskNoticeDefine',
        payload: {
          key: 'saveTaskNoticeDefine',
          apiParams: {
            businessId: taskId,
            templateList: taskNoticeInfo['templateList'],
          }
        }
      })
    }
        // if (taskNoticeInfo['needNotice'] && taskNoticeInfo['needNotice'] === 1) {
        //   let { noticeIds0, noticeIds1, noticeIds2 } = taskNoticeInfo
        //   if (noticeIds0 !== null && noticeIds0.length > 0) {
        //     this._addTaskNoticeInfo(noticeIds0, taskNoticeInfo['intervalNum0'], taskNoticeInfo['assignTime0'], taskNoticeInfo['noticeWhitelist0'])
        //   }
        //   if (noticeIds1 !== null && noticeIds1.length > 0) {
        //     this._addTaskNoticeInfo(noticeIds1, taskNoticeInfo['intervalNum1'], taskNoticeInfo['assignTime1'], taskNoticeInfo['noticeWhitelist1'])
        //   }
        //   if (noticeIds2 !== null && noticeIds2.length > 0) {
        //     this._addTaskNoticeInfo(noticeIds2, taskNoticeInfo['intervalNum2'], taskNoticeInfo['assignTime2'], taskNoticeInfo['noticeWhitelist2'])
        //   }
        // } else {
        //   this.doAction({
        //     path: 'noticeTemplate/saveTaskNoticeDefine',
        //     payload: {
        //       key: 'saveTaskNoticeDefine',
        //       apiParams: {
        //         businessId: taskId,
        //         state: 0
        //       }
        //     }
        //   })
        // }


        wizNotice.success(nextProps.addTaskInfo.msg)
        changeModal(false, true, true)
        // if (this._checkNextTab('1')) {
        //   nextState.activeKey = this._checkNextTab('1')
        // } else {
        //   changeModal(false, true)
        // }
      }
    } else {
      wizNotice.error('新增任务信息失败：' + nextProps.addTaskInfo.msg);
      return false;
    }
    return true;
  }

  _addFeaturedData(nextProps, nextState) {
    let { addFeaturedData, changeModal } = nextProps
    if (addFeaturedData && addFeaturedData.code == 1) {
      if (addFeaturedData.success) {
        wizNotice.success(nextProps.addFeaturedData.msg)
        changeModal(false, true, true)
        // if (this._checkNextTab('2')) {
        //   nextState.activeKey = this._checkNextTab('2')
        // } else {
        //   changeModal(false, true)
        // }
      }
    } else {
      wizNotice.error('新增推荐信息失败：' + nextProps.addFeaturedData.msg);
      return false;
    }
    return true;
  }

  _addMessageData(nextProps, nextState) {
    let { addMessageData, changeModal } = nextProps

    let { record, bizType } = nextState
    let { id,status,state } = record
    let isOpen = 0
    if(bizType==0 || bizType==1 ||bizType==15 || bizType==30){
      isOpen = status
    }else if(bizType==23 ){
      isOpen = state
    }
    if (addMessageData && addMessageData.code == 1) {
      if (addMessageData.success) {
        wizNotice.success(nextProps.addMessageData.msg)
        if(addMessageData.data && (bizType==0 || bizType==1 ||bizType==15 ||bizType==30 ||bizType==23 ||bizType==36 ) && isOpen==1){
        if(addMessageData.data>0){
        WizModal.confirm({
          title: '注意', content:"消息通知内容有变更，是否重新发送消息通知",cancelText:"否",okText:"是",
          onOk: () => {
            this.doActions([
              {
                path:  "notice/sendNotice",
                payload: {
                  key: "sendNoticeKey",
                  apiParams: {
                    bizId: id,
                    bizType,
                    resend:true
                  },
                },
              },
            ]);
          },
          onCancel: () => {
            this.doActions([
              {
                path:  "notice/sendNotice",
                payload: {
                  key: "sendNoticeKey",
                  apiParams: {
                    bizId: id,
                    bizType,
                    resend:false
                  },
                },
              },
            ]);
          }
        });
      }else{
        this.doActions([
          {
            path:  "notice/sendNotice",
            payload: {
              key: "sendNoticeKey",
              apiParams: {
                bizId: id,
                bizType,
                resend:false
              },
            },
          },
        ]);
      }
    }
        changeModal(false, true, true)
        // if (this._checkNextTab('3')) {
        //   nextState.activeKey = this._checkNextTab('3')
        // } else {
        //   changeModal(false, true)
        // }
      }
    } else {
      wizNotice.error('新增消息通知失败：' + nextProps.addMessageData.msg);
      return false;
    }
    return true;
  }


  _taskSubmit = (data) => {
    let { taskInfo, bizType, record, taskId } = this.state
    data['bizType'] = bizType
    data['bizId'] = record.id
    let apiPath = 'taskInfo/add'
    if (taskInfo && taskInfo.bizId) {
      apiPath = 'taskInfo/upd'
    } else {
      data['status'] = 1
      delete data['id']
    }
    this.setState({taskNoticeInfo:data,time:new Date().getTime()})
    this.doAction({
      path: apiPath,
      payload: {
        key: 'addTaskInfo',
        apiParams: {
          ...data
        }
      }
    })
  }

  _featuredSubmit = (data) => {
    let { featuredData, bizType, record, authInfo } = this.state
    let { id, name } = record
    data['entityType'] = bizType
    data['entityId'] = id
    data['entityName'] = name

    let apiPath = 'featured/create'
    if (featuredData && featuredData.id) {
      apiPath = 'featured/update'
    } else {
      delete data['id']
    }
    data['authInfo'] = authInfo
    this.doAction({
      path: apiPath,
      payload: {
        key: 'addFeaturedData',
        apiParams: {
          ...data
        }
      }
    })

  }

  _addMessageInfo = (taskId, templateList,messageNoticeIds,bizType) => {
    let list = templateList.filter(element=>messageNoticeIds.includes(element['id']))

    this.doAction({
      path: 'noticeTemplate/saveNoticeDefine',
      payload: {
        key: 'saveNoticeDefine',
        apiParams: {
          businessId: taskId,
          templateList: list,
          bizType:bizType,
          state: 1
        }
      }
    })
  }

  _messageSubmit = (data) => {

    let { record,bizType } = this.state
    let { id } = record
    if (data['noticeState'] && data['noticeState'] === 1 && data?.messageNoticeIds?.length) {
      this._addMessageInfo(id, data['templateList'],data.messageNoticeIds,bizType)
    } else {
      this.doAction({
        path: 'noticeTemplate/saveNoticeDefine',
        payload: {
          key: 'saveNoticeDefine',
          apiParams: {
            businessId: id,
            bizType:this.props.bizType,
            state: 0
          }
        }
      })
    }
  }
  _messageLoadPhoneTempCode = (data) => {
  }
  _changeTab = (key) => {
    this.setState({ activeKey: key })
    let { record, bizType } = this.state
    let { id } = record
    if (key === '1') {
      this.doAction({
        path: 'taskInfo/taskList',
        payload: {
          key: 'taskInfo@taskList',
          apiParams: {
            bizId: id,
            bizType: bizType
          }
        }
      })
    }
    if (key === '2') {
      this.doAction({
        path: 'featured/list',
        payload: {
          key: 'featured@featuredList',
          apiParams: {
            entityId: id,
            entityType: bizType
          }
        }
      })
    }
  }

  render() {
    let { taskInfo, messageData, taskNoticeData, featuredData, record, taskId, activeKey, bizType,labelInfo,initNow } = this.state
    let {changeModal} = this.props
    let taskNoticeIds = []
    if (taskId && taskId > 0) {
      if (taskNoticeData && taskNoticeData.length && taskNoticeData.length > 0) {
        taskNoticeData.forEach((e) => {
          e.sceneInfoList && e.sceneInfoList.length && e.sceneInfoList.forEach((value) => {
            if (value.state === 1) {
              taskNoticeIds.push(value.id)
            }
          })
        })
      }
    }
    //this.setState({ taskNoticeIds: taskNoticeIds })
    let messageNoticeIds = []
    let sceneNumbers = []
    if (messageData && messageData.length && messageData.length > 0) {
      let i = 0
      messageData.forEach((e) => {
        let noticeIds = []
        e.sceneInfoList && e.sceneInfoList.length && e.sceneInfoList.forEach((value) => {
          noticeIds.push(value.id)
          if (value.state === 1) {
            messageNoticeIds.push(value.id)
          }
        })
        sceneNumbers.push({ sceneName: e.sceneName, number: i, noticeIds: noticeIds })
        i++
      })
    }
    this.setState({ messageNoticeIds: messageNoticeIds })
    let tabs = {
      taskSet: <WizTabs.TabPane tab={'任务设置'} key={"1"}>
        <WizTaskSet key={'taskSet_'+ new Date().getTime()} record={taskInfo ? taskInfo : record} taskNoticeData={taskNoticeData}
          taskNoticeIds={taskNoticeIds}
          // noticeWhite={noticeWhite}
          initNow={initNow}
          labelInfo = {labelInfo}
          submit={(data) => this._taskSubmit(data)} />
      </WizTabs.TabPane>,
      recommendSet: <WizTabs.TabPane tab={'推荐设置'} key={"2"}>
        <WizFeaturedSet record={featuredData ? featuredData : record}
          submit={(data) => this._featuredSubmit(data)} />
      </WizTabs.TabPane>,
      MessageNotificationSet: <WizTabs.TabPane tab={'消息通知设置'} key={"3"}>
        <WizNoticeSet record={messageData || []} messageNoticeIds={messageNoticeIds}
          sceneNumbers={sceneNumbers}
          labelInfo = {labelInfo}
          initNow={initNow}
          submit={(data) => this._messageSubmit(data)} />
      </WizTabs.TabPane>,
      sceneAudience: <WizTabs.TabPane tab={'场景受众'} key={"4"}>
        <WizSceneAudienceSet bizType={bizType} bizId={record.id} validBiz={1} />
      </WizTabs.TabPane>,
      preconditions: <WizTabs.TabPane tab={'前置条件'} key={"5"}>
      <WizPreconditions bizType={bizType} bizId={record.id} changeModal={changeModal}/>
    </WizTabs.TabPane>,
    manageAuth: <WizTabs.TabPane tab={'管理权限'} key={"6"}>
    <WizManageAuth bizType={bizType} bizId={record.id} changeModal={changeModal}/>
  </WizTabs.TabPane>,
    }

    let showTabs = this.filterTabItems.map((btn) => {
      return btn && btn['code'] && tabs[btn['code']] ? tabs[btn['code']] : false
    }).filter(Boolean);

    return (
      <div className='highSet'>
        <WizTabs activeKey={activeKey} onChange={(e) => this._changeTab(e)} animated={false}>
          {showTabs}
        </WizTabs>
      </div>
    )
  }

}

const mapStateToProps = (state, ownProps) => {
  const { apply, taskInfo,thirdApp, noticeTemplate, featured } = state;
  const authInfo = modelUtils.getModelEntity(apply, "authInfoKey");
  const labelInfo = modelUtils.getModelEntity(thirdApp, "thirdApp@labelInfo");
  const taskData = modelUtils.getModelEntity(taskInfo, "taskInfo@taskList")
  const messageData = modelUtils.getModelEntity(noticeTemplate, 'noticeTemplate@noticeList')
  const taskNoticeData = modelUtils.getModelEntity(noticeTemplate, "noticeTemplate@taskNoticeList")
  const featuredData = modelUtils.getModelEntity(featured, 'featured@featuredList')

  const addTaskInfo = modelUtils.getModelEntity(taskInfo, 'addTaskInfo')
  const addFeaturedData = modelUtils.getModelEntity(featured, 'addFeaturedData')
  const addMessageData = modelUtils.getModelEntity(noticeTemplate, 'saveNoticeDefine')
  return {
    authInfo,
    taskData,
    labelInfo,
    taskNoticeData,
    messageData,
    featuredData,

    addTaskInfo,
    addFeaturedData,
    addMessageData
  }
};

const options = { withRef: true };

export default connect(mapStateToProps, null, null, options)(HighSet);

